import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { Fragment } from 'react';
import { ReactReduxContext } from 'react-redux'


class ShortEnrollmentButtons extends Component {

  constructor(props) {
    super(props)
  }
  handleButtonScroll(){
    var element = document.getElementById("enrollment-short");
    if (element) {
      const offset = 5;
      const topPosition =
        element.getBoundingClientRect().top + window.pageYOffset;

      window.scroll({
        top: topPosition - offset,
        left: 0,
        behavior: "smooth",
      });
    }
  }

  render() {

     return (
      <Fragment>
        <div className="container">
            <div className="row spacer-medium">&nbsp;</div>
            <div className="row">
                <div className="col-4 col-xs-1 col-sm-2 col-xl-1">
                    <button
                        id="pc-enrollment-received-nuplazid-yes"
                        style={{display: "inline-block", 
                            opacity: (this.props.consumerFormActive === 'no' ? "0.4" : "1")
                          }}
                        className="button white"
                        type="button"
                        onClick={
                          (e) => {
                            this.props.activateConsumerForm('yes')
                            this.handleButtonScroll();
                          }
                          
                        }
                    >
                        YES
                    </button>
                </div>
                <div className="col-4 col-xs-1 col-sm-2 col-xl-1">
                    <button
                        id="pc-enrollment-received-nuplazid-no"
                        style={{display: "inline-block", 
                            opacity: (this.props.consumerFormActive === 'yes' ? "0.4" : "1")
                          }}
                        className="button white"
                        type="button"
                        onClick={
                          (e) => {
                            this.props.activateConsumerForm('no')
                          }
                        }
                    >
                        NO
                    </button>
                </div>
            </div>
            <div className="row spacer-medium">&nbsp;</div>
          </div>
      </Fragment>        
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps, actions)(ShortEnrollmentButtons);